// src > UxGridFrame > IUxGridFrame
import { RefObject } from 'react'

export const defaultProps = Object.freeze({
	startIx: 10,
	scrollTop: 0,
	scrollLeft: 0
})

export type UxGridFrameScrollPosition = { scrollTop: number; scrollLeft: number }

export type UxGridFrameScrollState = {
	scrollHeight: number
	scrollWidth: number
	offsetHeight: number
	offsetWidth: number
	scrollRef: RefObject<HTMLDivElement>
	scrollTo(props: Partial<UxGridFrameScrollPosition>): void
} & UxGridFrameScrollPosition

export type UxGridFrameState = {
	shouldScroll: boolean
} & Pick<UxGridFrameScrollState, Exclude<keyof UxGridFrameScrollState, 'scrollRef' | 'scrollTo'>>

export type UxGridFrameProps = {
	// numCols: number
	// onReachBottom?(): void
	// onReachTop?(scrollRef: React.RefObject<HTMLDivElement>): void
	// render(scrollState: UxGridFrameScrollState): ReactNode
} & typeof defaultProps
